import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * TODO: Remove this route after launch Corpdrivee
 * @deprecated Legacy route for Dostavkee
 * @see /dostavkee/profile
 */
export const Route = createFileRoute('/(redirects)/profile')({
    beforeLoad: async () => {
        throw redirect({ to: '/dostavkee/profile' })
    },
})
